import React from "react";
import NumberUnitInput from "../../input/number-unit-input";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { useComponentBackgroundColor } from "../../common/adaptive-theme-provider";
import { Typography } from "@mhome/ui";

const NumberUnitDetail1Widget = ({ widget, onValueUpdate, pattern }) => {
  const getComponentBgColor = useComponentBackgroundColor();

  const handleValueUpdate = (value, unit, max, min) => {
    if (min !== null && value < min) {
      return;
    }
    if (max !== null && value > max) {
      return;
    }
    const updatedWidget = {
      ...widget,
      value: value.toString() + unit,
      unit,
      max,
      min,
    };
    onValueUpdate(updatedWidget);
  };

  const disabled = pattern && pattern.endsWith("_R");
  const showWarning = pattern && pattern.endsWith("_W");

  return (
    <div className="w-full flex flex-col">
      {/* Number Unit Controls Section */}
      <div
        className="flex flex-col rounded-2xl"
        style={{
          padding: "12px",
          backgroundColor: getComponentBgColor("hsl(var(--card))"),
        }}
      >
        <Typography className="mb-3 font-bold flex items-center gap-1 text-sm">
          Number Unit
          {showWarning && (
            <SyncProblemIcon
              fontSize="inherit"
              style={{ color: "hsl(var(--warning))" }}
            />
          )}
        </Typography>

        <div className="flex items-center h-full w-full">
          {widget && (
            <NumberUnitInput
              valueSpec={widget}
              onChange={handleValueUpdate}
              onError={() => {}}
              disabled={disabled}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default NumberUnitDetail1Widget;
